export default __webpack_public_path__ + "0db7200ebcea34e833eceb8df2a941a1.svg";